import { lazy } from "react";

export const KanbanBoard = lazy(() => import("@/features/kanban/KanbanBoard"));

export const LeadDetails = lazy(() => import("@/pages/Leads/LeadDetails"));

export const Listing = lazy(() => import("@/features/project-listing/Layout"));

export const BlogsListing = lazy(
  () => import("@/features/blogs/list-blogs-layout")
);

export const BlogDetails = lazy(() => import("@/features/blogs/blog-page"));


export const ComingSoon = lazy(() => import("@/features/crm/coming-soon"));

export const Calendar = lazy(() => import("@/features/calendar/Calendar"));

export const AddLead = lazy(() => import("@/features/crm/addLeads/add-leads"));

export const CRMConfigurations = lazy(
  () => import("@/features/crm-configurations/Layout")
);

export const ListView = lazy(
  () => import("@/features/kanban/views/listing-view")
);

export const ActivityView = lazy(
  () => import("@/features/kanban/views/activity-view")
);

export const NewActivityView = lazy(
  () => import("@/features/kanban/views/newActivityView")
);
export const EditLeadDetails = lazy(
  () => import("@/pages/Leads/edit-leaddetails")
);

export const Contacts = lazy(
  () => import("@/features/contacts/LayoutContacts")
);

export const AllApps = lazy(() => import("@/features/all-apps/Layout"));

export const Integration = lazy(() => import("@/features/integration/Layout"));

export const Quotes = lazy(() => import("@/features/quotes/LayoutQuotes"));

export const Invoicing = lazy(
  () => import("@/features/invoicing/LayoutInvoicing")
);

export const Contracts = lazy(
  () => import("@/features/contracts/LayoutContracts")
);

export const DiscussLayout = lazy(
  () => import("@/features/discuss/LayoutDiscuss")
);

export const Inbox = lazy(() => import("@/features/discuss/views/inbox/inbox"));

export const DirectMessage = lazy(
  () => import("@/features/discuss/views/direct-message/direct-message")
);

export const MarketingAutomation = lazy(
  () => import("@/features/marketing-automation/LayoutAutomation")
);

export const Analytics = lazy(
  () => import("@/features/analytics/layout-analytics")
);

export const PaymentSuccess = lazy(() => import("@/pages/payment-success"));

export const LoginSignup = lazy(
  () => import("@/features/onboarding/login/Login-Signup")
);

export const MyAccount = lazy(() => import("@/features/user-profile/layout"));

export const LoginForm =lazy(()=>import("@/features/onboarding/login/ui/login-form"));

export const  ForgotPasswordForm =lazy(()=>import("@/features/onboarding/login/ui/forgot-password-form"));

export const ForgotPasswordOtpForm =lazy(()=>import( "@/features/onboarding/login/ui/forgot-password-otp-form"));
export const ForgotPasswordReEnterPasswordForm =lazy(()=>import("@/features/onboarding/login/ui/forgot-password-re-enter-password-form"));
export const BMPAgent = lazy(
  () => import("@/features/onboarding/bmp-agent/bmp-agent")
);

export const NewBMPAgent = lazy(
  () => import("@/features/onboarding/bmp-agent-new/bmp-agent-new")
);

export const AdminLogin =lazy(()=>import("@/features/admin/login/admin-login"));


export const AdminUserList =lazy(()=>import("@/features/admin/layout"));

export const NewBMPAgent1 = lazy(
  () => import("@/components/dialogs/ai-agent-panel")
);

export const CompanyProfile = lazy(
  () => import("@/features/user-profile/company-profile/companyProfie")
);

export const CompanyProfileShareable = lazy(
  () => import("@/features/company-profile-shareable/Layout")
);
